import React from 'react'
import Fade from 'react-reveal/Fade'
import { CoverImg } from '../index'
import { contact } from '../../assets/imgs'
import './index.css'

const Contact = () =>
  <div>
    <Fade>
      <CoverImg alt="contact" src={contact} position="30% 50%" disclaimer />
    </Fade>
    <Fade>
      <div className="contact__content pa3 pa4-m relative-l flex-l flex-row-l m0-auto-l pa5-l">
        <div>
          <h2 className="serif fw4 f3 tl mb4 f1-ns">Contact</h2>
          <p className="fw3 f6 mb4 f4-ns">For any inquires concerning legal representation, press-related matters, or any other pertinent issue, please do not hesitate to contact The Law Office of Phillip Hamilton, PLLC.</p>
          <p className="fw3 f6 mb2 f4-ns">
            Phillip C. Hamilton, Esq.<br />
            <a href="mailto:Phil@PhillipHamiltonLaw.com" className="red">Phil@PhillipHamiltonLaw.com</a>
          </p>
          <p className="fw3 f6 mb2 f4-ns">
            Press Inquiries<br />
            <a href="mailto:Press@PhillipHamiltonLaw.com" className="red">Press@PhillipHamiltonLaw.com</a>
          </p>
          <p className="fw3 f6 mb2 f4-ns">
            Per Diem<br />
            <a href="mailto:PerDiem@PhillipHamiltonLaw.com" className="red">PerDiem@PhillipHamiltonLaw.com</a>
          </p>
        </div>

        <form className="relative flex flex-column items-start fw2 f6 mv5 f4-ns w-50-l flex-shrink-0-l ml7-l" method="POST" action="https://formspree.io/phil@philliphamiltonlaw.com">
          <input className="contact__input mb4 pa0" placeholder="Name (First & Last)" name="name" />
          <input className="contact__input mb4 pa0" placeholder="Email Address" name="email" />
          <div className="relative w-100 flex flex-column">
            <input className="contact__input mb4 pa0" placeholder="Subject" name="subject" />
            <label className="contact__textarea-label fw3">Summarize Your Case</label>
            <textarea className="contact__textarea mb4" name="summary" />
            <input className="contact__submit-btn bg-red white fw2 pointer f6 f4-ns trans-quick" type="submit" value="Submit" />
          </div>
        </form>
      </div>
    </Fade>
  </div>

export default Contact



// WEBPACK FOOTER //
// ./src/components/contact/index.js